// extracted by mini-css-extract-plugin
export default {"photoVideo":"PhotoVideo_photoVideo__WGqlc"};